import { theme } from 'antd';
import React from 'react';

import { Text, TextLink, useTheme } from '@desygner/ui-common-components';

import { StyledDisclaimerWrapper } from '../../AuthModal.styles';
import { DisclaimerLabelsT } from '../../AuthModal.types';

export const Disclaimer = ({ ...labels }: DisclaimerLabelsT) => {
  const theme = useTheme();

  return (
    <StyledDisclaimerWrapper>
      <Text size="Body" color={theme.Color.Neutrals.Gray}>
        {labels.text}
        <br />
        <TextLink size="Body" href="/terms-of-service">
          {labels.tosLinkText}
        </TextLink>{' '}
        {labels.and}{' '}
        <TextLink size="Body" href="/privacy-policy">
          {labels.ppLinkText}
        </TextLink>
      </Text>
    </StyledDisclaimerWrapper>
  );
};
